const tagPrefix = 'utm_'

export const getUTMParams = () => {
  const searchParams = new URLSearchParams(window.location.search);

  const utmParams = new Map<string, string>();

  searchParams.forEach((value, name) => {
    if (name.startsWith(tagPrefix)) {
      utmParams.set(name.replace(tagPrefix, ''), value);
    }
  });

  return Object.fromEntries(utmParams);
};
